import BlStepperShortProgressMv from './BlStepperShortProgressMv.vue'

BlStepperShortProgressMv.install = function(Vue) {
  Vue.component(BlStepperShortProgressMv.name, BlStepperShortProgressMv)
}

export default BlStepperShortProgressMv
